const DATA_MAP: {
  label: string, // label名称
  key: string, // 对应后端字段名
}[] = [
  {
    label: 'Founded Date',
    key: 'foundedDate_ymd',
  },
  {
    label: 'Last Funding Type',
    key: 'lastFundingType',
  },
  {
    label: 'Region/Country',
    key: 'location_city/location_country',
  },
  {
    label: 'IPO Status',
    key: 'ipoStatus',
  },
  {
    label: 'Also Known As',
    key: 'alsoKnownAs',
  },
  {
    label: 'Webside',
    key: 'website',
  },
];

export {
  DATA_MAP,
}
